<template>
  <div container class="merger-acquisition ">
    <form @submit.prevent="submitMergerAcquisition" method="POST">
      <div class=" mt-4 info-box">
        <!-- Client Name / Agency Info -->
        <div>
          <h2 class="grape text-captialize _pl0">{{ cloudCannonContent.title }}</h2>
          <cloud-cannon-content
            class="_p0 transparent grape"
            :content-loading="cloudCannonContentLoading"
            :content="cloudCannonContent.header_summary"
          />
        </div>

        <!-- Agency Name -->
        <div class="info-box"  grid="row wrap">
          <div column="xs-12 m-6 l-6">
            <app-input v-model="$v.merger.acquiredAgencyName.$model" label="Acquired Agency Name:" :error-message="acquiredAgencyNameError"
                       :invalid="$v.merger.acquiredAgencyName.$invalid" :required="true"></app-input>
          </div>
          <div column="xs-12 m-6 l-6">
            <app-input v-model="$v.merger.acquiringAgencyName.$model" label="Acquiring Agency Name:" :error-message="acquiringAgencyNameError"
                     :invalid="$v.merger.acquiringAgencyName.$invalid" :required="true"></app-input>
          </div>


          <div column="xs-12 m-6">
            <date-input
              v-model="$v.merger.effectiveDate.$model"
              :error-message="effectiveDateError"
              :invalid="$v.merger.effectiveDate.$invalid"
              :required="true"
              label="Effective Date"
              format="MM/DD/YYYY"/>
          </div>
      </div>

        <!-- New Agency Fields (Not Required) -->
        <div class="info-box"  grid="row wrap">
          <div column="xs-12 m-6 l-6">
            <app-input v-model="$v.merger.newAgencyName.$model" label="New Agency Name:" :error-message="newAgencyNameError"
                     :invalid="$v.merger.newAgencyName.$invalid"></app-input>
          </div>
          <div column="xs-12 m-6 l-6">
            <app-input v-model="$v.merger.newAgencyTaxId.$model" label="New Tax Id:" :error-message="newAgencyTaxIdError"
                                     :invalid="$v.merger.newAgencyTaxId.$invalid" ></app-input>
          </div>
          <div column="xs-12 m-6 l-6">
            <app-input v-model="$v.merger.newPhysicalAddress.$model" label="New Physical Address:" :error-message="newPhysicalAddressError"
                       :invalid="$v.merger.newPhysicalAddress.$invalid"></app-input>
          </div>
          <div column="xs-12 m-6 l-6">
            <app-input v-model="$v.merger.newPaymentAddress.$model" label="New Payment Address:" :error-message="newPaymentAddressError"
                       :invalid="$v.merger.newPaymentAddress.$invalid"></app-input>
          </div>
      </div>

      <div grid="row wrap" class="flex-column info-box" >
        <label class="color-black sub-heading">Agency Contact Information</label>
        <div grid="row wrap" class="info-box mt-2">
          <div column="xs-12 m-4">
            <app-input
              label="Name:"
              v-model="$v.merger.contactName.$model"
              :error-message="contactNameError"
              :invalid="$v.merger.contactName.$invalid"
              :required="true"
            />
          </div>
          <div column="xs-12 m-5">
            <app-input
              label="Email:"
              v-model="$v.merger.contactEmail.$model"
              :error-message="contactEmailError"
              :invalid="$v.merger.contactEmail.$invalid"
              :required="true"
            />
          </div>
          <div column="xs-12 m-3">
            <app-input
              label="Phone:"
              v-model="$v.merger.contactPhone.$model"
              :error-message="contactPhoneError"
              :invalid="$v.merger.contactPhone.$invalid"
              :required="true"
            />
          </div>
        </div>
        <!-- Attachments -->
        <div class="flex-column" column="xs-12 l-12">
          <span class="flex-column">
            <span class="flex-row" >
              <label>Attachments:</label>
              <validation-message :required="true" :invalid="$v.attachments.$invalid || failedFiles.length > 0" :errorMessage="attachmentsError"/>
            </span>
            <vue-dropzone
              id="dropzone"
              :key="dropZoneKey"
              ref="myVueDropzone"
              tabindex="0"
              class="_mbm"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              duplicate-check
              @keydown.stop.native.enter="manuallyOpenDropzone"
              @vdropzone-thumbnail="thumbnail"
              @vdropzone-files-added="checkFiles"
              @vdropzone-removed-file="checkFiles"
            >
              <p>
                {{ value.fileUploader.label }} <br /><strong>{{
                  value.fileUploader.validationMessage
                }}</strong>
              </p>
            </vue-dropzone>
          </span>
        </div>
      </div>

      <div grid="row wrap" class="button-panel">
        <button type="cancel" class="grape white _mtxs --sm" @click="$router.go(-1)">Cancel</button>
        <async-button type="submit" class="grape _mtxs --sm"  :executing="submissionLoading"
                      :disabled="this.$v.$invalid || this.failedFiles.length > 0" >
          <template #buttonContent>
            <span>Submit Payment merger</span>
          </template>
        </async-button>
      </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import formattable from '@mixins/formattable'
import cloudCannonable from '@mixins/CloudCannonable'
import fetchable from '@mixins/fetchable'
import AppPlaceholderInput from '@atoms/PlaceholderInput'
import AsyncLoader from '@molecules/AsyncLoader'
import tableSorter from '@mixins/tableSorter'
import dragdrop from '@mixins/dragdrop'
import AppAdvancedTable from '@organisms/AdvancedTable'
import ColumnPicker from '@molecules/ColumnPicker'
import DateInput from '@atoms/DateInput'
import Select from '@atoms/Select'
import AppInput from '@atoms/Input'
import ValidationMessage from '@atoms/ValidationMessage'
import AsyncButton from '@molecules/AsyncButton.vue'
import {addressFromAgency, currentOrFutureDate, nineDigits, phoneNumber, taxIdEinOrSsn} from '@utils';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import vue2Dropzone from 'vue2-dropzone'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as serviceDeskActionTypes from "@store/modules/serviceDesk/actionTypes";
import {alphaNum, email, maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import * as authActionTypes from "@store/modules/auth/actionTypes";

export default {
  name: 'BookOfRecord',
  mixins: [tableSorter, formattable, cloudCannonable, dragdrop, fetchable],
  components: {
    AppPlaceholderInput,
    FontAwesomeIcon,
    AsyncLoader,
    AppAdvancedTable,
    ColumnPicker,
    DateInput,
    AppInput,
    AsyncButton,
    Select,
    ValidationMessage,
    DateRangePicker,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      fetchers: [
        {
          action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
          options: {
            cloudCannonResource: '/service-desk-merger-acquisition.json',
          },
        },
      ],
      locationOptions: [{}],
      contactOptions: [{}],
      yesNoOptions: [
        { value: 'Y', text: 'Yes' },
        { value: 'N', text: 'No' }
      ],
      merger: {
        acquiringAgencyName: '',
        acquiredAgencyName: '',
        effectiveDate: '',
        newAgencyName: '',
        newAgencyTaxId: '',
        newPhysicalAddress: '',
        newPaymentAddress: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
      },
      attachments: '',
    }
  },
  methods: {
    isSubmitButtonDisabled(){
      if(this.failedFiles.length > 0 || this.$v.$invalid){
        return true
      }
      return false
    },
    reset() {
      this.clearForm()
    },
    clearForm() {
      this.dropZoneKey += 1
    },
    async updateAttachments() {
      this.$v.attachments.$model =  await this.$refs.myVueDropzone.getAcceptedFiles()
    },

    async submitMergerAcquisition(record){
      const redirect = () => this.$router.go(-1)
      this.$store.dispatch(serviceDeskActionTypes.SUBMIT_MERGER_ACQUISITION,
        { body: this.merger, attachments: this.attachments, redirect  } )
    },
  },
  computed: {
    ...mapGetters([
      'brokerPersonalInfo',
      'brokerPersonalInfoLoading',
      'submissionLoading',
      'contactType'
    ]),
    attachmentsError() {
      if(this.failedFiles.length > 0){
        return 'Remove failed upload(s)'
      } else if (!this.$v.attachments.required) {
        return 'Required'
      } else if (!this.$v.attachments.maxLength) {
        return '5 file max'
      }
      return null
    },
    clientNameError() {
      if (!this.$v.merger.clientName.required) {
        return 'required';
      } else if (!this.$v.merger.clientName.maxLength) {
        return '255 character max';
      }
      return null;
    },

    acquiringAgencyNameError(){
      if (!this.$v.merger.acquiringAgencyName.required) {
        return 'Required';
      } else if (!this.$v.merger.acquiringAgencyName.maxLength) {
        return '255 character max';
      }
      return null;
    },
    acquiredAgencyNameError(){
      if (!this.$v.merger.acquiredAgencyName.required) {
        return 'Required';
      } else if (!this.$v.merger.acquiredAgencyName.maxLength) {
        return '255 character max';
      }
      return null;
    },
    newAgencyNameError(){
      if (!this.$v.merger.newAgencyName.required) {
        return 'Required';
      } else if (!this.$v.merger.newAgencyName.maxLength) {
        return '255 character max';
      }
      return null;
    },
    newPhysicalAddressError(){
      if (!this.$v.merger.newPhysicalAddress.required) {
        return 'Required';
      } else if (!this.$v.merger.newPhysicalAddress.maxLength) {
        return '255 character max';
      }
      return null;
    },
    newPaymentAddressError(){
      if (!this.$v.merger.newPaymentAddress.required) {
        return 'Required';
      } else if (!this.$v.merger.newPaymentAddress.maxLength) {
        return '255 character max';
      }
      return null;
    },
    effectiveDateError() {
      if (!this.$v.merger.effectiveDate.required) {
        return 'required';
      } else if (!this.$v.merger.effectiveDate.currentOrFutureDate){
        return '>= current date'
      }
      return null;
    },
    contactNameError(){
      if (!this.$v.merger.contactName.required) {
        return 'Required';
      } else if (!this.$v.merger.contactName.maxLength) {
        return '80 character max';
      }
      return null;
    },
    contactEmailError(){
      if (!this.$v.merger.contactEmail.required) {
        return 'Required';
      } else if (!this.$v.merger.contactEmail.maxLength) {
        return '255 character max';
      } else if (!this.$v.merger.contactEmail.email) {
        return 'invalid email';
      }
      return null;
    },
    contactPhoneError(){
      if (!this.$v.merger.contactPhone.required) {
        return 'Required';
      } else if (!this.$v.merger.contactPhone.phoneNumber) {
        return 'bad format';
      }
      return null;
    },
    newAgencyTaxIdError(){
      if (!this.$v.merger.newAgencyTaxId.taxIdEinOrSsn) {
        return 'bad format';
      }
      return null;
    },
  },
  beforeMount() {
    if(this.contactType !== 'WRITING_BROKER'){
      this.dropzoneCallback = this.updateAttachments
    }else {
      const redirect = () => this.$router.go(-1)
      this.$store.dispatch(authActionTypes.SUBMIT_PAYMENT_INQUIRY_UNAUTHORIZED, { redirect } )
    }
  },
  validations: {
    attachments: {
      required,
    },
    merger: {
      acquiringAgencyName: {
        required,
        maxLength: maxLength(255)
      },
      acquiredAgencyName: {
        required,
        maxLength: maxLength(255)
      },
      effectiveDate: {
        required,
        currentOrFutureDate,
      },
      newAgencyName: {
        maxLength: maxLength(255)
      },
      newAgencyTaxId: {
        taxIdEinOrSsn,
      },
      newPhysicalAddress: {
        maxLength: maxLength(255)
      },
      newPaymentAddress: {
        maxLength: maxLength(255)
      },
      contactName: {
        required,
        maxLength: maxLength(80),
      },
      contactEmail: {
        required,
        email,
        maxLength: maxLength(255),
      },
      contactPhone: {
        required,
        phoneNumber,
      },
    },
  },
}
</script>
<style lang="scss" scoped>
span.validation {
  display: flex;
  align-items: center;
  margin-left: .3em;
}
</style>
